/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import "./button-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
import { ButtonItem as Button } from '@atlaskit/menu';
import { B400, B50, N30, N500 } from '@atlaskit/theme/colors';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
var styles = {
  root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhkqtfy _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
  selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};

/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
var ButtonItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    ref: ref
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ,

    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
    className: ax([styles.root, props.isSelected && styles.selectedStyles, className])
  }, props));
});
export default ButtonItem;